import Token from 'vindi-ds-tokens';

export default {
  homeContainer: {
    backgroundColor: Token.color.functional.light['100'].value,
    maxWidth: '1100px',
  },
  titleContainer: {
    paddingBottom: '0px',
  },
};
